import { fetchAllDataFromApi, getPieceFilterMapping,fetchAllDataFromApiNew, isMOQEnabled } from "../features/createSecondaryOrder/CreateSecondaryOrderService";
import { RecommendedType } from "../features/createSecondaryOrder/CreateSecondaryOrderType";
import { Catalogue, ProductMetadata, Product, Scheme, RecommendedData, TranformedmoqData } from "../features/createSecondaryOrder/models";
import { OrderType, StockOrder, TransformedRealTimeStock, UomConversionResult } from "../types/types";
import { clearAllDataFromLocalDb, getDataFromLocalDb, insertDataIntoLocalDB } from "./dbService";
import { addSchemesUsingPromoService, getSkuWiseMOQData, getSkuWiseOffers } from "./offersService";
import { getConfigData } from "../services/configurationService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "../services/networkService";
import { ARSPricingMap } from "../features/viewPrimaryOrder/ViewPrimaryOrder";
import { sendSlackAlert, SlackChannel } from "./slackService";
import { safeStringify } from "../components/dms_common/DmsUtils";

const PRODUCTS_API = "/products?minimalResponse=true&filter=activeStatus:active";
const ORDER_PRICING_API =
  "/productmetadata/v1/items/outlet?minimalResponse=true&filter=activeStatus:active";
const SALESMAM_PRICING_API = "/productmetadata/v1/pricing/secondary";
const RECOMMENDED_DATA_API = "/recommendedorders?minimalResponse=true&ignoreCount=true";
const ENTITY_MAPPING_API = "/v1/entitymapping";

export const fetchProducts = async () => {
  try {
    const size = 10000;
    const allProducts: Product[] = await fetchAllDataFromApi(PRODUCTS_API, size);
    const productMap: Record<string, Product> = {};
    for (let product of allProducts) {
      productMap[product?.batchCode] = product;
    }
    return productMap;
  } catch (error) {
    console.error("Error while fetching products", error);
    return {};
  }
};
export const fetchRouteIdNameMapping = async (currentUserLoginId: string) => {
  try {
    const size = 10000;
    const routeIdNameMapping = await fetchAllDataFromApi(`/v1/entitymapping/dynamic?filter=entityCategory:routeInfo and entityType:route and parentId:${currentUserLoginId}`, size);
    const mapping: Record<string, any> = {};
    routeIdNameMapping.forEach((item: any) => {
      mapping[item?.entityId] = item; 
    });
    return mapping;
  } catch (error) {
    console.error("Error while fetching routeIdName mapping", error);
    return {};
  }
};

const getPricingSkusUsingSalesRepAndEntityMapping = async (entityId: string, entityType: string, size: number = 1000): Promise<Set<string>> => {
  let url = `${ENTITY_MAPPING_API}?entityId=${entityId}&entityType=${entityType}`;
  let entityData = await fetchAllDataFromApi(url, size);
  const firstNode = entityData?.[0]; 
  return new Set(firstNode?.productInfo?.map((item: any) => item?.skuCode));
}

export const getPricingData = async (outletCode: string | undefined, salesRep: string | undefined, orderType: OrderType, primaryOmsFlow: boolean, selectedDistributor?: string, fetchDistributorPricing?: boolean) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const loginId = JSON.parse(localStorage.authContext).user.loginId;
    const size = 10000;
    const {
      fetchPricingBySalesrep
    } = ConfigDictionary;
    const useSalesrepForPricing: boolean = fetchPricingBySalesrep && fetchPricingBySalesrep;

    const pricingConfig = await getConfigData(
      "catalogue_configuration",
      "product_pricing_config"
    );
    
    const pricingSalesmanConfig = await getConfigData(
      "catalogue_configuration",
      "product_pricing_salesman_config"
    );
    const pricingSalesmanApi = pricingSalesmanConfig[0]?.configValue ?? false;

    const pricingApiConfig = pricingConfig[0]?.configValue ?? false;
    // Wrap pricing API call
    let pricingData: ProductMetadata[];
    try {
      if (pricingApiConfig) {
        pricingData = await fetchAllDataFromApi(`/productmetadata/v1/items/pricing?minimalResponse=true&filter=activeStatus:active&outletCode=${outletCode}`,size);  
      }
      else if(pricingSalesmanApi) {
        if(orderType === OrderType.SECONDARY) {
          pricingData = await fetchAllDataFromApi(`/productmetadata/v1/items/pricing?outletCode=${salesRep}`,size);  
          pricingData = pricingData?.filter((s: ProductMetadata) => s?.supplier === selectedDistributor ? selectedDistributor : loginId);
        }else {
          pricingData = await fetchAllDataFromApiNew(`/productmetadata/v1/items/pricing${selectedDistributor ? `?outletCode=${selectedDistributor}` : ""}`,size);  
        }
      } 
      else if(useSalesrepForPricing && salesRep && orderType === OrderType.SECONDARY) {
        let result = await getPricingSkusUsingSalesRepAndEntityMapping(salesRep, "user");
        const allPricingData = await fetchAllDataFromApi(`${SALESMAM_PRICING_API}?salesman=${salesRep}`, size);
        pricingData = allPricingData?.filter(s => result.has(s?.skuCode));
      } else if(orderType === OrderType.PRIMARY && fetchDistributorPricing) {
        pricingData = await fetchAllDataFromApi(
          `${ORDER_PRICING_API}&loginId=${selectedDistributor}`,
          size
        );
      } else {
      pricingData = await fetchAllDataFromApi(
        orderType === OrderType.SECONDARY
          ? `${ORDER_PRICING_API}&loginId=${outletCode}`
          : `${ORDER_PRICING_API}&loginId=${primaryOmsFlow ? outletCode : JSON.parse(localStorage.authContext)?.user?.loginId}`,
        size
      );
    }
    } catch (error) {

      if (orderType === OrderType.SECONDARY) {
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Error in getPricingData",
          "Error occurred while fetching product pricing data. This may prevent products from displaying in the UI.",
          safeStringify({ outletCode, salesRep, orderType, primaryOmsFlow, error })
        );
      } else if (orderType === OrderType.PRIMARY) {
        await sendSlackAlert(
          SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
          "Error in getPricingData",
          "Error occurred while fetching product pricing data. This may prevent products from displaying in the UI.",
          safeStringify({ outletCode, salesRep, orderType, primaryOmsFlow, error})
        );
      }

      throw new Error("pricing");
    }
  return pricingData;
}

export const createPricingForArsSkus = (arsPricingMap: ARSPricingMap, products: Record<string, any>): Catalogue[] => {
  const enrichedProducts: ProductMetadata[] = [];

  for (const batchCode in arsPricingMap) {
    if (arsPricingMap.hasOwnProperty(batchCode)) {
      const pricing = arsPricingMap[batchCode];
      const product = products[batchCode];

      if (pricing) {
        const enrichedProduct: ProductMetadata = {
          id: product.id ?? batchCode,
          lastModified: product?.lastModified ?? new Date(),
          manufacturingDateV1: product?.manufacturingDateV1 ?? new Date(),
          name: product?.skuName ?? "",
          packPtr: pricing?.piecePtr ?? 0,
          casePtr: pricing?.casePtr ?? 0,
          caseMrp: product?.caseMrp ?? 0,
          mrp: product?.mrp ?? 0,
          srp: product?.srp ?? 0,
          description: product?.skuDescription ?? "",
          quantity: product?.quantity ?? 0,
          case2Piece: product?.caseToPieceQuantity ?? 0,
          supplier: product?.supplier ?? "",
          activeStatus: product?.activeStatus ?? "active",
          otherUnitMrp: product?.otherUnitMrp ?? 0,
          otherUnitPtr: pricing?.otherUnitPtr ?? 0,
          groupIdV1: product?.groupId ?? "",
          discountMargin: product?.discountMargin ?? 0,
          batchCode: product?.batchCode ?? "",
          skuCode: product?.skuCode ?? "",
          outletCode: product?.outletCode ?? "",
          tax: product?.tax ?? 0,
          specialPrice: product?.specialPrice ?? 0,
          caseToPieceQuantity: product?.caseToPieceQuantity ?? 0,
          caseToOtherUnitQuantity: product?.caseToOtherUnitQuantity ?? 0,
          otherUnitToPieceQuantity: product?.otherUnitToPieceQuantity ?? 0,
          pieceToOtherUnitQuantity: product?.pieceToOtherUnitQuantity ?? 0,
          channel: product?.channel ?? "",
          referenceKey: product?.referenceKey ?? "",
        };

        enrichedProducts.push(enrichedProduct);
      }
    }
  }

    let transformedData: Catalogue[] = [];
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const orderUomCheck = ConfigDictionary.orderUomCheck ?? "";
    enrichedProducts?.forEach((pm: Record<string, any>) => {
      if (products[pm?.batchCode]) {
        const product = products[pm.batchCode];
        const skuDescription = product.skuDescription || pm.skuName || "";
        const newPieceSize = getPieceFilterMapping(product?.pieceSize)
        let searchValue =
          [
            product?.batchCode ?? "",
            product?.brand ?? "",
            product?.category ?? "",
            skuDescription ?? "",
            product?.skuName ?? "",
            product?.subCategory ?? "",
            newPieceSize,
          ]?.join("") ?? "";
        searchValue = searchValue?.replace(/\s+/g, "")?.toLocaleLowerCase();

        const catalogue: Catalogue = {
          flavour: product?.flavour,
          id: product?.batchCode,
          name: product?.skuDescription || product?.skuName,
          description: skuDescription,
          productDescription: product?.productDescription,
          suggestedQty: 0,
          suggestedCaseQty: 0,
          suggestedOtherQty: 0,
          case2Piece: product?.caseToPieceQuantity,
          images: product?.images,
          imageUrl: product?.blobKey,
          category: product?.category,
          subCategory: product?.subCategory,
          brand: product?.brand,
          skuCode: product?.skuCode,
          batchCode: product?.batchCode,
          priority: product?.priority,
          pieceSize: product?.pieceSize,
          pieceSizeDesc: product?.pieceSizeDesc,
          suggestionText: product?.suggestionText,
          productTag: "",
          itemClass: product?.itemClass,
          packPtr: pm?.packPtr ?? 0,
          casePtr: pm?.casePtr ?? 0,
          mrp: pm?.mrp ?? 0,
          caseMrp: pm?.caseMrp ?? 0,
          feature: "",
          sellingStory: "",
          subCategoryCode: product?.subCategoryCode,
          customLevel: 0,
          level: 0,
          searchIndex: 0,
          isFavourite: "false",
          isRecommended: "",
          recommendationType: "",
          recommendationId: "",
          recommendationPriority: 0,
          recommendedQty:  0,
          basketId: "",
          offers: "",
          supplier: pm?.supplier,
          tax: 0,
          marketSkuCode: "",
          otherUnitMrp: product?.otherUnitMrp,
          otherUnitToPieceQuantity: product?.otherUnitToPieceQuantity,
          pieceToOtherUnitQuantity: product?.pieceToOtherUnitQuantity,
          otherUnitPtr: pm?.otherUnitPtr,
          additionalSchemeDescription: "",
          otherUnitName: product?.otherUnitName ?? "",
          smartBuy: "",
          stockQty: 0,
          groupIdV1: "",
          recommendedAttributesV2: "",
          maxBenefitStringV1: "",
          itemDescV1: "",
          uom: orderUomCheck === "true" ? (product?.uom ?? "") : "all",
          typeV1: "",
          bandedMaxQuantityV1: 0,
          minQtyForEarnPoints: 0,
          productCode: product?.extendedAttributes?.PRODUCTCODE,
          shelfLife: product?.extendedAttributes?.shelfLife ?? 0,
          srp: 0,
          returnCode: "",
          discountMargin: 0,
          outOfStock: false,
          isNotify: false,
          secondaryProductTag: "",
          eb2bCode: "",
          sbu: "",
          eanCode: "",
          searchValue,
          availableCaseQty: 0,
          availablePieceQty: 0,
          availableOtherQty: 0,
          availableNormalizedQty: 0,
          schemes: [],
        };

        transformedData.push(catalogue);
      }
    });
  return transformedData;
};

export const createCatalogue = async (
  orderType: OrderType,
  outletCode?: string,
  getSchemes: boolean = false,
  orderedBatchCodes?: string [],
  salesRep?: string,
  isOneClickAllowed?: boolean,
  primaryOmsFlow?: boolean,
  selectedDistributor?: string,
  skipmissingBatchCodesCheck?: boolean,
) => {
  try {
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const size = 10000;
    const dbResult = await getDataFromLocalDb("Product");
    const products: any = dbResult?.data?.[0]?.data ?? {};

    // Wrap pricing API call
    let pricingData: ProductMetadata[] = await getPricingData(outletCode, salesRep, orderType, primaryOmsFlow ?? false, selectedDistributor);

    let recommedationFilter = `activeStatus:active and outletCode:${outletCode}`;
    let recommendedApi = salesRep ? `${RECOMMENDED_DATA_API}&filter=${recommedationFilter}&loginId=${salesRep}` : `${RECOMMENDED_DATA_API}&filter=${recommedationFilter}`;
    let recommendedData: RecommendedData[] | undefined = (isOneClickAllowed && isOneClickAllowed) ? await fetchAllDataFromApi(recommendedApi, size): undefined;
    if(recommendedData) {
      recommendedData = aggregateRecommendedData(recommendedData);
    }

    if(orderedBatchCodes && orderedBatchCodes?.length && !skipmissingBatchCodesCheck) {

      const missingBatchCodes = orderedBatchCodes.filter(
        (code) => !pricingData.some((item) => item?.batchCode === code)
      );

      if (missingBatchCodes.length > 0) {
        await sendSlackAlert(
          orderType === OrderType.SECONDARY
            ? SlackChannel.DMS_SECONDARY_UI_NOTIFICATION
            : SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
          "Missing BatchCodes in Pricing Data",
          "Some batch codes from order are not found in pricing data. This may result in missing SKUs in UI.",
          safeStringify({
            outletCode,
            salesRep,
            orderType,
            orderedBatchCodes,
            missingBatchCodes
          })
        );
      }

      const allPresent: boolean = orderedBatchCodes?.every((code) =>
        pricingData?.some((obj) => obj?.batchCode === code)
      );

      if (!allPresent) {    
        throw new Error("missingPricing");
      }
    }

    const stocksData = await getDataFromLocalDb("RealTimeStockData");

    let skuWiseStockData: StockOrder = {};
    stocksData?.data?.forEach((stock: TransformedRealTimeStock) => {
      const availableCaseQty = stock?.caseQty?.availableQty || 0;
      const availablePieceQty = stock?.pieceQty?.availableQty || 0;
      const availableOtherQty = stock?.otherQty?.availableQty || 0;
      skuWiseStockData[stock?.skuCode] = { availableCaseQty, availableOtherQty, availablePieceQty };
    });

    const {
      usePromoServiceForSchemes
    } = ConfigDictionary;

    let skuWiseOffers: Record<string, Scheme[]> = {};
    if (outletCode && getSchemes && !usePromoServiceForSchemes) {
      skuWiseOffers = await getSkuWiseOffers(outletCode);
    }

    const designation = JSON.parse(localStorage.authContext).user.designation || [];
      
    let enableMOQCheck = false;
    
    const enableMOQCheckConfig = ConfigDictionary?.enableMOQCheck;
    if (enableMOQCheckConfig?.enable) enableMOQCheck = isMOQEnabled(designation, enableMOQCheckConfig)

    let skuWiseMOQData: TranformedmoqData = {}
    if (enableMOQCheck){
      skuWiseMOQData = await getSkuWiseMOQData()
    }

    let transformedData: Catalogue[] = [];
    const orderUomCheck = ConfigDictionary.orderUomCheck ?? "";
    pricingData?.forEach((pm: Record<string, any>) => {
      if (products[pm?.batchCode]) {
        const product = products[pm.batchCode];
        const recommendedBatchData: RecommendedData | undefined = recommendedData?.find(s => s.skuCode === pm.skuCode);
        const isRecommended = recommendedBatchData !== undefined ? "true" : "false";
        const skuDescription = product.skuDescription || pm.skuName || "";
        const newPieceSize = getPieceFilterMapping(product?.pieceSize)
        let searchValue =
          [
            product?.batchCode ?? "",
            product?.brand ?? "",
            product?.category ?? "",
            skuDescription ?? "",
            product?.skuName ?? "",
            product?.subCategory ?? "",
            newPieceSize,
          ]?.join("") ?? "";
        searchValue = searchValue?.replace(/\s+/g, "")?.toLocaleLowerCase();

        const catalogue: Catalogue = {
          id: product?.batchCode,
          name: product?.skuDescription || product?.skuName,
          description: skuDescription,
          flavour: product?.flavour,
          productDescription: product?.productDescription,
          suggestedQty: 0,
          suggestedCaseQty: 0,
          suggestedOtherQty: 0,
          case2Piece: product?.caseToPieceQuantity,
          images: product?.images,
          imageUrl: product?.blobKey,
          category: product?.category,
          subCategory: product?.subCategory,
          brand: product?.brand,
          skuCode: product?.skuCode,
          batchCode: product?.batchCode,
          priority: product?.priority,
          pieceSize: product?.pieceSize,
          pieceSizeDesc: product?.pieceSizeDesc,
          suggestionText: product?.suggestionText,
          productTag: "",
          itemClass: product?.itemClass,
          packPtr: pm?.packPtr ?? 0,
          casePtr: pm?.casePtr ?? 0,
          mrp: pm?.mrp ?? 0,
          caseMrp: pm?.caseMrp ?? 0,
          feature: "",
          sellingStory: "",
          subCategoryCode: product?.subCategoryCode,
          customLevel: 0,
          level: 0,
          searchIndex: 0,
          isFavourite: "false",
          isRecommended: isRecommended,
          recommendationType: recommendedBatchData?.recommendationType ?? "",
          recommendationId: recommendedBatchData?.id ?? "",
          recommendationPriority: recommendedBatchData?.skuPriority ?? 0,
          recommendedQty: recommendedBatchData?.pieceQuantity ?? 0,
          basketId: recommendedBatchData?.basketId ?? "",
          offers: "",
          supplier: pm?.supplier,
          tax: 0,
          marketSkuCode: "",
          otherUnitMrp: product?.otherUnitMrp,
          otherUnitToPieceQuantity: product?.otherUnitToPieceQuantity,
          pieceToOtherUnitQuantity: product?.pieceToOtherUnitQuantity,
          otherUnitPtr: pm?.otherUnitPtr,
          additionalSchemeDescription: "",
          otherUnitName: product?.otherUnitName ?? "",
          smartBuy: "",
          stockQty: 0,
          groupIdV1: "",
          recommendedAttributesV2: "",
          maxBenefitStringV1: "",
          itemDescV1: "",
          uom: orderUomCheck === "true" ? (product?.uom ?? "") : "all",
          typeV1: "",
          bandedMaxQuantityV1: 0,
          minQtyForEarnPoints: 0,
          productCode: product?.extendedAttributes?.PRODUCTCODE,
          shelfLife: product?.extendedAttributes?.shelfLife ?? 0,
          srp: 0,
          returnCode: "",
          discountMargin: 0,
          outOfStock: false,
          isNotify: false,
          secondaryProductTag: "",
          eb2bCode: "",
          sbu: "",
          eanCode: "",
          searchValue,
          availableCaseQty: skuWiseStockData?.[product?.batchCode]?.["availableCaseQty"] ?? 0,
          availablePieceQty: skuWiseStockData?.[product?.batchCode]?.["availablePieceQty"] ?? 0,
          availableOtherQty: skuWiseStockData?.[product?.batchCode]?.["availableOtherQty"] ?? 0,
          availableNormalizedQty: (
            (skuWiseStockData?.[product?.batchCode]?.["availableCaseQty"] ?? 0) * (product?.caseToPieceQuantity ?? 0)
          ) + (
            (skuWiseStockData?.[product?.batchCode]?.["availableOtherQty"] ?? 0) * (product?.otherUnitToPieceQuantity ?? 0)
          ) + (
            skuWiseStockData?.[product?.batchCode]?.["availablePieceQty"] ?? 0
          ),
          schemes: skuWiseOffers[product?.batchCode] ?? [],
          ...(skuWiseMOQData[product?.batchCode] ?? {}),
          itemId: product?.itemId,
          capacity: product?.capacity
        };
        if(isRecommended) {
            const recommendationType: RecommendedType = catalogue.recommendationPriority === 0 ? "regular" : (catalogue.recommendationPriority === 1 ? "must-try" : (catalogue.recommendationPriority === 2) ? "recovery" : undefined);
            const defaultUomConversionResult: UomConversionResult = {
              convertedCaseQty: 0,
              convertedPieceQty: 0,
              convertedOtherQty: 0
            };
            const { convertedCaseQty, convertedOtherQty, convertedPieceQty }: UomConversionResult = (recommendationType === "recovery" || recommendationType === "regular" || recommendationType === "must-try") ? convertUomUsingNq(catalogue.recommendedQty ?? 0, catalogue.uom, catalogue.case2Piece, catalogue.otherUnitToPieceQuantity, catalogue.availableCaseQty, catalogue.availableOtherQty, catalogue.availablePieceQty, false) : defaultUomConversionResult;
            catalogue.suggestedQty = convertedPieceQty;
            catalogue.suggestedCaseQty = convertedCaseQty;
            catalogue.suggestedOtherQty = convertedOtherQty;
        }

        transformedData.push(catalogue);
      }
    });

    if(outletCode && getSchemes && !!usePromoServiceForSchemes) {
      transformedData = await addSchemesUsingPromoService(transformedData, outletCode)
    }

    if(orderType === OrderType.SECONDARY) {
      await clearAllDataFromLocalDb("Catalogue");
      await insertDataIntoLocalDB("Catalogue", transformedData)
    } else {
      await clearAllDataFromLocalDb("PrimaryCatalogue");
      await insertDataIntoLocalDB("PrimaryCatalogue", transformedData);
    }
    return transformedData;
  } catch (err) {

    const slackChannel =
    orderType === OrderType.SECONDARY
      ? SlackChannel.DMS_SECONDARY_UI_NOTIFICATION
      : SlackChannel.DMS_PRIMARY_UI_NOTIFICATION;

      await sendSlackAlert(
        slackChannel,
        "Error in createCatalogue",
        "An unexpected error occurred while building the catalogue. It may block UI rendering.",
        safeStringify({
          outletCode,
          orderType,
          salesRep,
          getSchemes,
          primaryOmsFlow,
          err
        })
      );

    console.error("Error while creating catalogue", err);
    throw err;
  }
};

export async function prepareCatalogue() {
  try {
    await createCatalogue(OrderType.PRIMARY);
  } catch (err) {
    console.log("Error while preparing the catalogue", err);
  }
}

export const performUomConversion = (
  caseQty: number,
  otherQty: number,
  pieceQty: number,
  uom: string,
  caseToPieceQty: number,
  otherToPieceQty: number,
  caseStock: number,
  otherStock: number,
  pieceStock: number,
  skipStockExceedCheck?: boolean,
  otherUnitName?: string,
): UomConversionResult => {  
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    disableOtherUnitNameWiseCavinKair,
    uomConversion,
  } = ConfigDictionary;

  const availableUoms = uom?.replace(/\s+/g, "").split(",");
  const disablePieceUom = (!availableUoms.includes("all") && !availableUoms.includes("ea"));
  const disableCaseUom = (!availableUoms.includes("all") && !availableUoms.includes("cs")) || (uomConversion && (caseToPieceQty === 0));
  const disableOtherUom = (!availableUoms.includes("all") && !availableUoms.includes("other")) || (uomConversion && (otherToPieceQty === 0)) || (disableOtherUnitNameWiseCavinKair && otherUnitName?.trim().length === 0);

  let hasQtyExceededStock = false;

  let normalizedQty = caseQty * caseToPieceQty + otherQty * otherToPieceQty + pieceQty;
  const normalizedStock = caseStock * caseToPieceQty + otherStock * otherToPieceQty + pieceStock;

  if (!skipStockExceedCheck && normalizedQty > normalizedStock) {
    hasQtyExceededStock = true;
    normalizedQty = normalizedStock;
  }

  let convertedCaseQty = 0;
  let convertedOtherQty = 0;
  let convertedPieceQty = 0;

  if (!disableCaseUom && caseToPieceQty && normalizedQty) {
    convertedCaseQty = Math.floor(normalizedQty / caseToPieceQty);
    normalizedQty -= (convertedCaseQty * caseToPieceQty);
  }
  if (ConfigDictionary.otherUnitLabel && !disableOtherUom && otherToPieceQty && normalizedQty) {
    convertedOtherQty = Math.floor(normalizedQty / otherToPieceQty);
    normalizedQty -= (convertedOtherQty * otherToPieceQty);
  }
  if (!disablePieceUom) {
    convertedPieceQty = normalizedQty;
  }

  return {
    convertedCaseQty,
    convertedOtherQty,
    convertedPieceQty,
    hasQtyExceededStock
  }
};

export const performUomConversionPrimary = (
  caseQty: number,
  otherQty: number,
  pieceQty: number,
  uom: string,
  caseToPieceQty: number,
  otherToPieceQty: number,
  caseStock: number,
  otherStock: number,
  pieceStock: number,
  skipStockExceedCheck?: boolean,
): UomConversionResult => {  
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  const availableUoms = uom?.replace(/\s+/g, "").split(",");
  const disablePieceUom = !availableUoms.includes("all") && !availableUoms.includes("ea");
  const disableCaseUom = !availableUoms.includes("all") && !availableUoms.includes("cs");
  const disableOtherUom = !availableUoms.includes("all") && !availableUoms.includes("other");

  let hasQtyExceededStock = false;

  let normalizedQty = caseQty * caseToPieceQty + otherQty * otherToPieceQty + pieceQty;
  const normalizedStock = caseStock * caseToPieceQty + otherStock * otherToPieceQty + pieceStock;

  // if (!skipStockExceedCheck && normalizedQty > normalizedStock) {
  //   hasQtyExceededStock = true;
  //   normalizedQty = normalizedStock;
  // }

  let convertedCaseQty = 0;
  let convertedOtherQty = 0;
  let convertedPieceQty = 0;

  const canUseCase = !!(!disableCaseUom && caseToPieceQty && normalizedQty);
  const canUseOther = !!(ConfigDictionary.otherUnitLabelPrimary && !disableOtherUom && otherToPieceQty && normalizedQty);

  const convertCase = () => {
    if (canUseCase) {
      convertedCaseQty = Math.floor(normalizedQty / caseToPieceQty);
      normalizedQty -= (convertedCaseQty * caseToPieceQty);
    }
  };

  const convertOther = () => {
    if (canUseOther) {
      convertedOtherQty = Math.floor(normalizedQty / otherToPieceQty);
      normalizedQty -= (convertedOtherQty * otherToPieceQty);
    }
  };

  if (caseToPieceQty > otherToPieceQty) {
    convertCase();
    convertOther();
  } else if (caseToPieceQty < otherToPieceQty) {
    convertOther();
    convertCase();
  } else {
    if (pieceQty >= caseToPieceQty) {
      convertCase()
      convertOther();
      if (!disablePieceUom) {
        convertedPieceQty = normalizedQty;
      }
      return {
        convertedCaseQty,
        convertedOtherQty,
        convertedPieceQty,
        hasQtyExceededStock
      }
    }
    convertedCaseQty = caseQty;
    convertedOtherQty = otherQty;
    convertedPieceQty = pieceQty;
    return {
      convertedCaseQty,
      convertedOtherQty,
      convertedPieceQty,
      hasQtyExceededStock
    }
  }
  
  if (!disablePieceUom) {
    convertedPieceQty = normalizedQty;
  }

  return {
    convertedCaseQty,
    convertedOtherQty,
    convertedPieceQty,
    hasQtyExceededStock
  };
};

export const performUomConversionPrimaryReturn = (
  caseQty: number,
  otherQty: number,
  pieceQty: number,
  uom: string,
  caseToPieceQty: number,
  otherToPieceQty: number,
  caseStock: number,
  otherStock: number,
  pieceStock: number,
  skipStockExceedCheck?: boolean,
): UomConversionResult => {  
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  const availableUoms = uom?.replace(/\s+/g, "").split(",");
  const disablePieceUom = !availableUoms.includes("all") && !availableUoms.includes("ea");
  const disableCaseUom = !availableUoms.includes("all") && !availableUoms.includes("cs");
  const disableOtherUom = !availableUoms.includes("all") && !availableUoms.includes("other");

  let hasQtyExceededStock = false;

  let normalizedQty = caseQty * caseToPieceQty + otherQty * otherToPieceQty + pieceQty;
  const normalizedStock = caseStock * caseToPieceQty + otherStock * otherToPieceQty + pieceStock;

  // if (!skipStockExceedCheck && normalizedQty > normalizedStock) {
  //   hasQtyExceededStock = true;
  //   normalizedQty = normalizedStock;
  // }

  let convertedCaseQty = 0;
  let convertedOtherQty = 0;
  let convertedPieceQty = 0;

  const canUseCase = !!(!disableCaseUom && ConfigDictionary?.caseUnitLabelPrimaryReturn && caseToPieceQty && normalizedQty);
  const canUseOther = !!(ConfigDictionary?.otherUnitLabelPrimaryReturn && !disableOtherUom && otherToPieceQty && normalizedQty);

  const convertCase = () => {
    if (canUseCase) {
      convertedCaseQty = Math.floor(normalizedQty / caseToPieceQty);
      normalizedQty -= (convertedCaseQty * caseToPieceQty);
    }
  };

  const convertOther = () => {
    if (canUseOther) {
      convertedOtherQty = Math.floor(normalizedQty / otherToPieceQty);
      normalizedQty -= (convertedOtherQty * otherToPieceQty);
    }
  };

  if (caseToPieceQty > otherToPieceQty) {
    convertCase();
    convertOther();
  } else if (caseToPieceQty < otherToPieceQty) {
    convertOther();
    convertCase();
  } else {
    if (pieceQty >= caseToPieceQty) {
      convertCase()
      convertOther();
      if (!disablePieceUom) {
        convertedPieceQty = normalizedQty;
      }
      return {
        convertedCaseQty,
        convertedOtherQty,
        convertedPieceQty,
        hasQtyExceededStock
      }
    }
    convertedCaseQty = caseQty;
    convertedOtherQty = otherQty;
    convertedPieceQty = pieceQty;
    return {
      convertedCaseQty,
      convertedOtherQty,
      convertedPieceQty,
      hasQtyExceededStock
    }
  }
  
  if (!disablePieceUom && ConfigDictionary.packUnitLabelPrimaryReturn) {
    convertedPieceQty = normalizedQty;
  }

  return {
    convertedCaseQty,
    convertedOtherQty,
    convertedPieceQty,
    hasQtyExceededStock
  };
};



export const convertUomUsingNq = (
  normalizedQty: number,
  uom: string,
  caseToPieceQty: number,
  otherToPieceQty: number,
  caseStock: number,
  otherStock: number,
  pieceStock: number,
  skipStockExceedCheck?: boolean,
): UomConversionResult => {
  const availableUoms = uom?.replace(/\s+/g, "").split(",");
  const disablePieceUom = !availableUoms.includes("all") && !availableUoms.includes("ea");
  const disableCaseUom = !availableUoms.includes("all") && !availableUoms.includes("cs");
  const disableOtherUom = !availableUoms.includes("all") && !availableUoms.includes("other");

  let hasQtyExceededStock = false;
  const normalizedStock = caseStock * caseToPieceQty + otherStock * otherToPieceQty + pieceStock;

  if (!skipStockExceedCheck && normalizedQty > normalizedStock) {
    hasQtyExceededStock = true;
    normalizedQty = normalizedStock;
  }

  let convertedCaseQty = 0;
  let convertedOtherQty = 0;
  let convertedPieceQty = 0;

  if (!disableCaseUom && caseToPieceQty) {
    convertedCaseQty = Math.floor(normalizedQty / caseToPieceQty);
    normalizedQty -= convertedCaseQty * caseToPieceQty;
  }

  if (!disableOtherUom && otherToPieceQty) {
    convertedOtherQty = Math.floor(normalizedQty / otherToPieceQty);
    normalizedQty -= convertedOtherQty * otherToPieceQty;
  }

  if (!disablePieceUom) {
    convertedPieceQty = normalizedQty;
  }

  return {
    convertedCaseQty,
    convertedOtherQty,
    convertedPieceQty,
    hasQtyExceededStock,
  };
};

function aggregateRecommendedData(data: RecommendedData[]): RecommendedData[] {
    const aggregatedMap = new Map<string, RecommendedData>();

    for (const item of data) {
        if (aggregatedMap.has(item.batchCode)) {
            const existing = aggregatedMap.get(item.batchCode)!;

            if (
                (existing.skuPriority === 2 && item.skuPriority === 0) ||
                (existing.skuPriority === 0 && item.skuPriority === 2)
            ) {
                //NOTE: Merge both pieceQuantities and set skuPriority as 2
                existing.pieceQuantity += item.pieceQuantity;
                existing.skuPriority = 2;
            }
        } else {
            // Add the first occurrence of batchCode
            aggregatedMap.set(item.batchCode, { ...item });
        }
    }

    return Array.from(aggregatedMap.values());
}

// API to get distinct sets and their associated items (products or outlets)
export async function getDistinctTagSets(productValue: 'product' | 'outlet') {
    const response = await ChannelkartNetworkGet(`/v1/product/tag/distinctTags/${productValue}`);
    return response;
}

// API to get distinct outlet set names
export async function getDistinctOutletSetNames() {
    const response = await ChannelkartNetworkGet('/v1/catalogueSequence/distinctOutletSets');
    return response;
}

// API to create catalogue sequence mapping
export async function createCatalogueSequenceMapping(mappings: { outletSet: string; productSet: string | null }[]) {
    const response = await ChannelkartNetworkPost('/v1/catalogueSequence', mappings, {
        'Content-Type': 'application/json',
    });
    return response;
}

// API to get mapped outlet/product sets
export async function getMappedCatalogueSequences() {
    const response = await ChannelkartNetworkGet('/v1/catalogueSequence');
    return response;
}
